export default (function() {
  const P = Promise

  if (typeof P.prototype.finally === 'function') {
    return
  }

  let species
  if (typeof Symbol !== 'undefined' && Symbol !== null) {
    species = Symbol.species
  }
  const R = Function.prototype.call.bind(P.resolve)
  P.prototype.finally = function(onFinally) {
    switch (typeof this) {
      case 'function':
        break
      case 'object':
        if (this !== null) {
          break
        }
      // eslint-disable-next-line no-fallthrough
      default:
        throw new TypeError('Promise.prototype.finally called on non-object')
    }
    const cons = this.constructor
    let C
    switch (typeof cons) {
      case 'undefined':
        C = P
        break
      case 'function':
      case 'object':
        if (cons !== null) {
          // tslint:disable-next-line:no-conditional-assignment
          if (species == null || (C = cons[species]) == null) {
            C = P
          } else if (typeof C !== 'function') {
            throw new TypeError('...[@@species] is not a function')
          }
          break
        }
      // eslint-disable-next-line no-fallthrough
      default:
        throw new TypeError('constructor is not an object')
    }
    // We simply assume `C` has a [[Construct]] internal slot.
    let thenFinally
    let catchFinally

    if (typeof onFinally !== 'function') {
      thenFinally = catchFinally = onFinally
    } else {
      thenFinally = function(x) {
        return R(C, onFinally()).then(function() {
          return x
        })
      }
      catchFinally = function(x) {
        return R(C, onFinally()).then(function() {
          throw x
        })
      }
    }
    return this.then(thenFinally, catchFinally)
  }
})()
